import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";

import { Links as PublicLinks, AdminLink } from "../constants/Links";
import { useAdminRole } from "../services/adminAuth";

export default function Header() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const role = useAdminRole();
  const Links = role ? [...PublicLinks, AdminLink] : PublicLinks;
  const currentPage =
    Links.find(link => link.url === location.pathname)?.title
    ?? "Open JC Sambreville";

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#ff0000",
        }}
      >
        <Toolbar>

          {mobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={() => setOpen(true)}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {mobile && (
            <Typography variant="body2">
              {currentPage}
            </Typography>
          )}

          {!mobile && (
            <Box
              sx={{
                display: "flex",
                gap: 3,
              }}
            >
              {Links.map((link) => (
                <Link
                  key={link.url}
                  to={link.url}
                  style={{
                    color: location.pathname === link.url
                      ? "#fdd00a"
                      : "white",
                    textDecoration: "none",
                    fontWeight:
                      location.pathname === link.url
                        ? 700
                        : 400
                  }}
                >
                  {link.title}
                </Link>
              ))}
            </Box>
          )}

        </Toolbar>
      </AppBar >

      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box sx={{ width: 280 }}>
          <List>
            {Links.map((link) => (
              <ListItemButton
                key={link.url}
                component={Link}
                to={link.url}
                onClick={() => setOpen(false)}
              >
                <ListItemText primary={link.title} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>

      <Toolbar />
    </>
  );
}